<!-- Component that implements a list of documents -->
<template lang="html">
  <v-container class='fluid'>

    <v-layout align-center justify-center>
      <v-flex xs10>
        <v-card>
          <basic-toolbar :title="'Frequência do Bolsista'"></basic-toolbar>

          <v-card-text>
            <v-layout row wrap justify-center>
              <v-flex xs11>
                <v-text-field
                  label='Nome do Bolsista'
                  v-model="integrante.nome"
                  readonly
                  max-height="400">
                </v-text-field>
              </v-flex>
            </v-layout>

            <br><br>

            <v-data-table
            :headers="headers"
            :items="listaFrequencia"
            :search="search"
            :no-data-text="'Nenhuma frequência encontrada'"
            must-sort
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :items-per-page="itemsPerPage"
            :footer-props="{itemsPerPageText: 'Linhas por página', itemsPerPageOptions: opcoesPaginacao}"
            >
              <template slot="items" slot-scope="props">
                <tr>
                  <td width="10%" class="text-xs-center">{{ props.item.ano }}</td>
                  <td width="10%" class="text-xs-center">{{ props.item.mes }}</td>
                  <td width="30%" class="text-xs-center">{{ props.item.observacao ? props.item.observacao : '-'  }}</td>
                  <td width="50%" class="text-xs-center">{{ props.item.atividadesRealizadas ? props.item.atividadesRealizadas : '-' }}</td>
                </tr>
              </template>
              <template slot="footer.page-text" slot-scope="{ pageStart, pageStop }">
                Mostrando {{ pageStart }} a {{ pageStop }} de {{ listaFrequencia.length }} frequências
              </template>
            </v-data-table>
          </v-card-text>
          <br>
          <v-divider></v-divider>
          <v-card-actions>
            <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
            <v-spacer></v-spacer>
            <v-btn v-if="administrador === true || (projeto.funcao != null && projeto.funcao.item === 1)" color="primary" text @click="toCriarFrequencia">Nova frequência</v-btn>
          </v-card-actions>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import bolsas from '@/utils/bolsas'
import { mapGetters, mapActions } from 'vuex'

export default {
  data: () => ({
    listaFrequencia: [],
    projeto: {},
    integrante: {},
    dates: dates,
    search: null,
    sortBy: 'dtCriacao',
    sortDesc: true,
    itemsPerPage: 10,
    opcoesPaginacao: [ 10, 25, 50, {text: 'Todas', value: -1} ],
    headers: [
      { text: 'Ano', align: 'left', value: 'ano' },
      { text: 'Mês', align: 'left', value: 'mes' },
      { text: 'Observação', align: 'left', value: 'observacao' },
      { text: 'Atividades Realizadas', align: 'left', value: 'atividadesRealizadas' }
    ]
  }),
  computed: {
    ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
  },
  props: ['items', 'idProjeto', 'idParticipante'],
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    truncate (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    toCriarFrequencia: function () {
      this.$router.push({name: 'CriarFrequencia'})
    }
  },
  mounted () {
    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' })
    projetos.getIntegrante(this.idProjeto, this.idParticipante)
    .then(response => {
      this.integrante = response.data
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando integrante.' })
    })

    projetos.getProjeto(this.idProjeto)
    .then(response => {
      this.projeto = response.data
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
    })

    this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando frequências.' })
    bolsas.getFrequencias(this.idProjeto, this.idParticipante)
    .then(response => {
      this.listaFrequencia = response.data.slice()
    })
    .catch(error => {
      console.log('Erro ao mandar o request' + error)
    })
    .finally(() => {
      this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando frequências.' })
    })
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip
  }
}
</script>

<style lang="css" slot-scoped>
</style>



// WEBPACK FOOTER //
// lista-frequencia.vue?6c4a04ca